import './styles/App.scss'
import {BrowserRouter, Routes, Route} from 'react-router-dom'
import Navbar from './components/home-components/navbar/Navbar'
import Home from './pages/Home/Home'
import Footer from './components/home-components/footer/Footer'
import Contact from './pages/Contact/Contact'
import Auth from './pages/Login/Auth'
import Explore from './pages/Explore/Explore'
import Totop from './Helpers/Totop'
import SingleHouse from './components/explore-components/houses/single-house/SingleHouse'
// import { houseContext, FilterHouse } from './HouseContext'

const App = () => {
  return (

    <BrowserRouter>
    {/* <houseContext> */}
    <div className="App">
      <Navbar/>
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/explore' element={<Explore/>}/>
        <Route path='/explore/:title' element={<SingleHouse/>}/>
        <Route path='/login' element={<Auth/>}/>
        <Route path='/contact-us' element={<Contact/>}/>
      </Routes>
      <Footer/>
      <Totop/>
    </div>
    {/* </houseContext> */}
    </BrowserRouter>
  );
}

export default App;
